import React, { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import api from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Box,
  Divider,
  Stack,
  Grid,
  Typography,
  Input,
  TextField,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getId, getISTDate } from "../../../utils/Constant";
import ButtonWithLoader from "../../../utils/ButtonWithLoader";
import CustomLabel from "../../../CustomLable";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
// import CustomDataGrids from "../../../utils/CustomDataGrids";
import CustomDataGrid from "../../../utils/CustomDatagrid";
import DataGrids from "../../../utils/Datagrids";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function ZoneMaster() {
  const Userid = getId();
  const { defaultValuestime } = getISTDate();
  const [editId, setEditId] = useState(0);
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  console.log('location', location)

  const [lang, setLang] = useState<Language>("en");
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });


  console.log('permissionData', permissionData)


  const { t } = useTranslation();

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    if (dataString) {
      const data = JSON.parse(dataString);
      if (data && data.length > 0) {
        const userPermissionData = data[0]?.userPermission;
        if (userPermissionData && userPermissionData.length > 0) {
          const menudata = userPermissionData[0]?.parentMenu;
          for (let index = 0; index < menudata.length; index++) {
            const childMenudata = menudata[index]?.childMenu;

            // console.log('childMenudata', childMenudata)
            const pathrow = childMenudata.find(
              (data: any) => data.path === location.pathname
            ) || null;
            console.log("data", pathrow);
            if (pathrow) {

              setPermissionData(pathrow);
            }
          }
        }
      }
    }

    fetchZonesData();
  }, []);
  // }, [isLoading]);

  useEffect(() => {

    getPageSetUp();

  }, []);


  const [showStates, setShowStates] = useState({ showState1: false });






  const getPageSetUp = () => {
    api.get(`PageSetup/GetPageSetupData?PageId=-1`).then((res) => {
      const data = res?.data?.data;


      // const setupItem = data.find((item: any) => item.setupId === 2);

      const setupItem1 = data.find((item: any) => item.setupId === 6);

      setShowStates({
        // showState: setupItem ? setupItem.showHide : false,
        showState1: setupItem1 ? setupItem1.showHide : false,
      });
    });
  };


  const handleConversionChange = (params: any, text: string) => {
    formik.setFieldValue(params, text);
  };



  const routeChangeEdit = (row: any) => {
    console.log(row);
    formik.setFieldValue("zoneID", row.zoneID);
    formik.setFieldValue("zoneName", row.zoneName);
    formik.setFieldValue("zoneAbbrevation", row.zoneAbbrevation);
    formik.setFieldValue("checked", row.checked);
    setEditId(row.id);
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      zoneID: delete_id,
      user_ID: Userid,
      isActive: true,
    };
    console.log("collectData " + JSON.stringify(collectData));
    api
      .delete(`Zone/DeleteZonemaster`, { data: collectData })
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchZonesData();
      });
  };

  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchZonesData = async () => {
    try {
      const collectData = {
        zoneID: -1,
        user_ID: Userid
      };
      const response = await api.post(`Zone/GetZonemaster`, collectData);
      const data = response.data.data;
      // console.log("🚀 ~ fetchZonesData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.zoneID,
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            // headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params: any) => {
              console.log("Is Edit Allowed:", permissionData?.isEdit);
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit  ? ( */}


                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => routeChangeEdit(params.row)}
                  />
                  {/* ) : (
                    ""
                  )} */}
                  {/* {permissionData?.isDel ? ( */}
                  <DeleteIcon
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handledeleteClick(params.row.id);
                    }}
                  />
                  {/* ) : (
                    ""
                  )} */}

                </Stack>,
              ];
            },
          },

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "zoneName",
            headerName: t("text.zoneName"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "zoneAbbrevation",
            headerName: t("text.zoneCode"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
            hideable:showStates.showState1,
          },

        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  const validationSchema = Yup.object({
    zoneName: Yup.string().test(
      "required",
      t("text.reqZoneName"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      zoneID: 0,
      zoneName: "",
      zoneAbbrevation: "",
      srno: 0,
      checked: true,
      user_ID: Userid,
      "createdBy": Userid,
      "updatedBy": Userid,
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.zoneID = editId;

      console.log("before submitting value check", values);
      const response = await api.post(`Zone/AddUpdateZonemaster`, values);
      if (response.data.status === 1) {
        formik.setFieldValue("zoneName", "");
        formik.setFieldValue("zoneAbbrevation", "");
        formik.resetForm();
        fetchZonesData();
        toast.success(response.data.message);
        setEditId(0);
      } else {
        toast.error(response.data.message);
      }
    },
  });

  const handleSubmitWrapper = async () => {
    await formik.handleSubmit();
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "lightgreen",
          border: ".5px solid #2B4593",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            // backgroundColor:"lightseagreen"
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Grid item xs={12} container spacing={1}>
            <Grid item lg={10} md={10} xs={12}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ padding: "20px" }}
                align="left"
              >
                {t("text.zoneMaster")}
              </Typography>
            </Grid>

            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>

          <Divider />

          <Box height={10} />
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} container spacing={2}>

              {/* {showStates.showState && ( */}
                <Grid xs={12} sm={5} lg={5} item>
                  <TranslateTextField
                    label={t("text.enterZoneName")}
                    value={formik.values.zoneName}
                    onChangeText={(text: string) => handleConversionChange('zoneName', text)}
                    required={true}
                    lang={lang}
                  />
                  {formik.touched.zoneName && formik.errors.zoneName ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {formik.errors.zoneName}
                    </div>
                  ) : null}
                </Grid>
              {/* )} */}

              {showStates.showState1 && (
                <Grid item xs={12} sm={5} lg={5}>
                  <TextField
                    label={
                      <CustomLabel
                        text={t("text.enterZoneCode")}
                        required={false}
                      />
                    }
                    variant="outlined"
                    fullWidth
                    size="small"
                    name="zoneAbbrevation"
                    id="zoneAbbrevation"
                    value={formik.values.zoneAbbrevation}
                    placeholder={t("text.enterZoneCode")}
                    onChange={formik.handleChange}
                  />
                </Grid>

              )}


              <Grid item xs={2} sx={{ m: -1 }}>

                {editId === 0 && permissionData?.isAdd && (
                  <ButtonWithLoader
                    buttonText={t("text.save")}
                    onClickHandler={handleSubmitWrapper}
                    fullWidth={true}
                  />
                )}

                {editId !== 0 && (
                  <ButtonWithLoader
                    buttonText={t("text.update")}
                    onClickHandler={handleSubmitWrapper}
                    fullWidth={true}
                  />
                )}
              </Grid>
            </Grid>
          </form>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <DataGrids
              isLoading={isLoading}
              rows={zones}
              columns={adjustedColumns}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              initialPageSize={5}
              columnVisibilityModel ={{zoneAbbrevation: showStates.showState1, } }
            />
          )}
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
};